<template>
    <div class="pagination-box" v-show="pageparams.total !== 0">
        <el-pagination
                background
                layout="total,prev, pager, next"
                @current-change="handlePage"
                :page-size="pageparams.pageSize"
                :total="pageparams.total"
                :current-page="pageparams.page">
        </el-pagination>
    </div>
</template>
<script>
    export default {
        props: ['pageparams'],
        methods: {
            handlePage(val) {
                this.$emit('handlePage', val)
            }
        }
    }
</script>
